import React, { ReactNode } from 'react';

import * as S from './styles';
import InfoIcon from '@material-ui/icons/Info';

interface NoticeList {
  text: string;
}

interface NoticeEvaluationProps {
  noticeList?: NoticeList[];
  headerText?: ReactNode;
}

const NoticeEvaluation = ({
  noticeList,
  headerText,
}: NoticeEvaluationProps) => {
  return (
    <S.NoticeBox>
      {headerText && (
        <S.NoticeHeader>
          <InfoIcon />
          {headerText}
        </S.NoticeHeader>
      )}
      {noticeList?.length > 0 && (
        <S.NoticeBody>
          <S.NoticeList>
            {noticeList?.map((notice, index) => (
              <li
                key={index}
                dangerouslySetInnerHTML={{ __html: notice.text }}
              />
            ))}
          </S.NoticeList>
        </S.NoticeBody>
      )}
    </S.NoticeBox>
  );
};
export default NoticeEvaluation;
